export const STORAGE_KEYS = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  ORDER_DRAFT: "orderDraft",
  PLAN_CHANGE_NOTIFICATION: "planChangeNotification",
} as const;

export const getItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error(`Error reading from localStorage (${key}):`, error);
    return null;
  }
};

export const setItem = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error(`Error writing to localStorage (${key}):`, error);
  }
};

export const removeItem = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing from localStorage (${key}):`, error);
  }
};

export const getJSON = <T = any>(key: string): T | null => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;
    return JSON.parse(item) as T;
  } catch (error) {
    console.error(`Error parsing JSON from localStorage (${key}):`, error);
    return null;
  }
};

export const setJSON = <T = any>(key: string, value: T): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error saving JSON to localStorage (${key}):`, error);
  }
};

export const clear = (): void => {
  try {
    localStorage.clear();
  } catch (error) {
    console.error("Error clearing localStorage:", error);
  }
};

export const authStorage = {
  getAccessToken: () => getItem(STORAGE_KEYS.ACCESS_TOKEN),
  setAccessToken: (token: string) => setItem(STORAGE_KEYS.ACCESS_TOKEN, token),
  removeAccessToken: () => removeItem(STORAGE_KEYS.ACCESS_TOKEN),

  getRefreshToken: () => getItem(STORAGE_KEYS.REFRESH_TOKEN),
  setRefreshToken: (token: string) =>
    setItem(STORAGE_KEYS.REFRESH_TOKEN, token),
  removeRefreshToken: () => removeItem(STORAGE_KEYS.REFRESH_TOKEN),

  clearTokens: () => {
    removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  },
};

export const orderStorage = {
  getDraft: <T = any>() => getJSON<T>(STORAGE_KEYS.ORDER_DRAFT),
  setDraft: <T = any>(draft: T) => setJSON(STORAGE_KEYS.ORDER_DRAFT, draft),
  removeDraft: () => removeItem(STORAGE_KEYS.ORDER_DRAFT),
};

export const notificationStorage = {
  getPlanChange: <T = any>() =>
    getJSON<T>(STORAGE_KEYS.PLAN_CHANGE_NOTIFICATION),
  setPlanChange: <T = any>(notification: T) =>
    setJSON(STORAGE_KEYS.PLAN_CHANGE_NOTIFICATION, notification),
  removePlanChange: () => removeItem(STORAGE_KEYS.PLAN_CHANGE_NOTIFICATION),
};
